class action{
  constructor(
    label           = 'string', 
    iconClassName   = 'mdi mdi-arrow-right', 
    onClick         = null, 
    show            = true,
    disabled        = false, // add
    position        = 'left',
    iconOnly        = false
  ){
    this.label = label
    this.iconClassName = iconClassName
    this.onClick = onClick
    this.show = show
    this.disabled = disabled // add
    this.position = position
    this.iconOnly = iconOnly
  }
}

export default action